import {
    BoundedContent,
    Box,
    BulletList,
    BulletListContent,
    Column,
    GridContainer,
    H2,
    Icon,
    Li,
    P,
    Row,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { __, __image } from '@99designs/i18n';
import { CloudinaryImage } from '../CloudinaryImage/';

const ResponsiveCoverImage = styled.img`
    text-align: center;
    max-height: var(--swan-comp-banner-image-container-size-max-height);
    max-width: 100%;

    @media (min-width: ${tokensRaw.SwanBaseBreakpointSmStart}) {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        max-height: 100%;
        transform: translate(-50%, -50%);
        padding-left: var(--swan-sem-space-8);
    }
`;

const TextContainer = styled(Box)`
    display: flex;
    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        align-items: center;
    }
    @media (min-width: ${tokensRaw.SwanBaseBreakpointSmStart}) {
        padding-top: var(--swan-sem-space-5);
        padding-bottom: var(--swan-sem-space-5);
    }
    @media (max-width: ${tokensRaw.SwanBaseBreakpointSmEnd}) {
        justify-content: center;
    }
`;

const Text = styled(Box)`
    display: flex;
    flex-direction: column;
    min-height: var(--swan-comp-banner-size-min-height-standard);
    margin-left: var(--swan-comp-banner-text-offset);
    justify-content: center;

    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        align-items: center;
        max-width: 600px;
    }

    @media (min-width: ${tokensRaw.SwanBaseBreakpointSmStart}) {
        padding-left: var(--swan-sem-space-6);
    }
`;

const ImageContainer = styled(Box)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointSmEnd}) {
        text-align: center;
    }
`;

export const WhyHireOnVistaprint = () => {
    return (
        <BoundedContent paddingTop="6" paddingBottom="5">
            <GridContainer>
                <Row>
                    <Column span={6} spanXs={12} verticallyCenterContent>
                        <TextContainer>
                            <Text>
                                <H2
                                    textAlign={{ xs: 'center', sm: 'left' }}
                                    marginBottom="between-subsections"
                                >
                                    {__('Why choose VistaPrint?')}
                                </H2>
                                <BulletList>
                                    <Li>
                                        <Icon iconType={'ai'} marginRight={4} />
                                        <BulletListContent>
                                            <div>
                                                <strong>
                                                    {__('Leave it to the professionals')}
                                                </strong>
                                            </div>
                                            <P marginTop={3}>
                                                {__(
                                                    'Our global community of vetted, professional designers will create and deliver every pixel-perfect file and format you need.'
                                                )}
                                            </P>
                                        </BulletListContent>
                                    </Li>
                                    <Li>
                                        <Icon iconType={'heart'} marginRight={4} />
                                        <BulletListContent>
                                            <div>
                                                <strong>{__('Stick to your budget ')}</strong>
                                            </div>
                                            <P marginTop={3}>
                                                {__(
                                                    'From minor tweaks to complete redesigns – we offer a range of services to grow your brand without breaking the bank.'
                                                )}
                                            </P>
                                        </BulletListContent>
                                    </Li>
                                    <Li>
                                        <Icon iconType={'liveChat'} marginRight={4} />
                                        <BulletListContent>
                                            <div>
                                                <strong>{__('24/7 customer support')}</strong>
                                            </div>
                                            <P marginTop={3}>
                                                {__(
                                                    'Our Customer Care Team are here to support you with your design or print journey – whenever you need it.'
                                                )}
                                            </P>
                                        </BulletListContent>
                                    </Li>
                                    <Li>
                                        <Icon iconType={'delivery'} marginRight={4} />
                                        <BulletListContent>
                                            <div>
                                                <strong>
                                                    {__(
                                                        'Design, print, store, deliver – all in one place'
                                                    )}
                                                </strong>
                                            </div>
                                            <P marginTop={3}>
                                                {__(
                                                    'All your designs are stored within your VistaPrint account, ready to print onto marketing materials, merch, packaging and more.'
                                                )}
                                            </P>
                                        </BulletListContent>
                                    </Li>
                                </BulletList>
                            </Text>
                        </TextContainer>
                    </Column>
                    <Column span={6} spanXs={12}>
                        <ImageContainer>
                            <CloudinaryImage
                                render={(props) => (
                                    <ResponsiveCoverImage
                                        src={props.src}
                                        srcSet={props.srcSet}
                                        alt=""
                                        role="presentation"
                                    />
                                )}
                                imagePath={__image(
                                    'expert_services/HubPage/why-hire-on-vistaprint-image'
                                )}
                                width={800}
                            />
                        </ImageContainer>
                    </Column>
                </Row>
            </GridContainer>
        </BoundedContent>
    );
};
